<template>
  <div class="flex gap-x-2">
    <component
      :is="Filters[filter.type]"
      v-for="filter in options.filters"
      :key="filter.key"
      v-model="value"
      :filter-key="filter.key"
      :options="filter.options"
      class="!w-full"
      :class="filter.class"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import type { Filter } from '@components/utils/filter/Filter.vue';
import Filters from '@components/utils/filter/filterTypes';

export interface Options {
  filters: Filter[]
}

export interface Props<Value = never> {
  modelValue: Record<string, Value>;
  filterKey: string;
  options: Options;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
